<template>
  <div id="app">
    <div class="app-container">
      <router-view />
      <MainNavBar v-if="showBottomNav" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import MainNavBar from "@/components/MainNavBar.vue";
import configManager from "@/utils/configManager";

export default {
  name: "App",
  components: {
    MainNavBar,
  },
  setup() {
    const route = useRoute();

    // 根据当前路由决定是否显示底部导航
    // 现在所有页面都显示底部导航
    const showBottomNav = computed(() => {
      return true;
    });

    onMounted(() => {
      // 应用初始化时加载配置
      configManager.init();

      // 初始化主题 - 从localStorage读取保存的主题设置
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    });

    return {
      showBottomNav,
    };
  },
};
</script>

<style>
@import './assets/styles/colors.css';
@import './assets/styles/base.css';
@import './assets/styles/components.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

.app-container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: constant(safe-area-inset-top); /* 兼容旧版本 */
  padding-top: env(safe-area-inset-top);
}

/* 路由视图容器 */
.route-view-container {
  flex: 1;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu,
    Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  margin: 0;
  padding: env(safe-area-inset-top, 0) env(safe-area-inset-right, 0) calc(80px + env(safe-area-inset-bottom, 0)) env(safe-area-inset-left, 0); /* 为顶部安全区域和底部导航留出空间 */
  color: var(--text-primary);
  background: var(--bg-primary);
  line-height: 1.5;
}
</style>
